/**
 * RouteNotFound — what an unregistered route resolves to.
 *
 * decision-2026-07-25-broker-mode-split, restated gate 9(b): navigating directly to
 * a route this deployment does not register must yield NOT FOUND, not a role prompt.
 * A role prompt says "this capability exists here and you lack the role"; on a tenant
 * broker the provisioning capability does not exist at all, and the surface must say
 * so honestly.
 */

interface Props {
  route: string;
  onHome: () => void;
}

export default function RouteNotFound({ route, onHome }: Props) {
  return (
    <div
      className="dp-shell__content"
      data-testid="route-not-found"
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 'var(--sp-3)',
        padding: 'var(--sp-12)',
      }}
    >
      <p className="dp-eyebrow">Not found</p>
      <h2>No such page on this broker</h2>
      <p
        style={{
          color: 'var(--fg-3)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-body-sm)',
          textAlign: 'center',
          maxWidth: 460,
        }}
      >
        <code>{route}</code> is not a route on this instance.
      </p>
      <button className="dp-btn dp-btn--ghost" onClick={onHome}>
        Back to marketplace
      </button>
    </div>
  );
}
